export const PRE_AUTH_LOCALE_COOKIE_NAME = "preauthLangLocale";
export const POST_AUTH_LOCALE_COOKIE_NAME = "postauthLangLocale";
export const LOCALE_SEARCH_PARAM_NAME = "lang-locale";
export const USE_EVALUATE_ABORT_ERROR_REASON = "USE_EVALUATE_FEATURE_UNMOUNT";
